import React from 'react'

type TruckOrderTabIconProps = {
  testId?: string
}

export function TruckOrderTabIcon({ testId }: TruckOrderTabIconProps) {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      data-testid={testId}
    >
      <path
        d="M4.54787 16.406C5.96149 16.406 7.10746 15.2601 7.10746 13.8465C7.10746 12.4328 5.96149 11.2869 4.54787 11.2869C3.13425 11.2869 1.98828 12.4328 1.98828 13.8465C1.98828 15.2601 3.13425 16.406 4.54787 16.406Z"
        fill="none"
        stroke="#412DEE"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M18.3174 16.406C19.731 16.406 20.877 15.2601 20.877 13.8465C20.877 12.4328 19.731 11.2869 18.3174 11.2869C16.9038 11.2869 15.7578 12.4328 15.7578 13.8465C15.7578 15.2601 16.9038 16.406 18.3174 16.406Z"
        fill="none"
        stroke="#412DEE"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M16.2967 0.770996H0.769531V13.0832H16.2967V0.770996Z"
        fill="none"
        stroke="#412DEE"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M23.2285 13.0524H16.6445V4.90332H21.3474L23.2285 13.0524Z"
        fill="none"
        stroke="#412DEE"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M16.9844 8.40356H21.8723"
        stroke="#412DEE"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  )
}
